/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface CountWidgetData
 */
export interface CountWidgetData {
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof CountWidgetData
     */
    total: ApiUserTasksGetPageParameter;
}

/**
 * Check if a given object implements the CountWidgetData interface.
 */
export function instanceOfCountWidgetData(value: object): value is CountWidgetData {
    if (!('total' in value) || value['total'] === undefined) return false;
    return true;
}

export function CountWidgetDataFromJSON(json: any): CountWidgetData {
    return CountWidgetDataFromJSONTyped(json, false);
}

export function CountWidgetDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): CountWidgetData {
    if (json == null) {
        return json;
    }
    return {
        
        'total': ApiUserTasksGetPageParameterFromJSON(json['total']),
    };
}

export function CountWidgetDataToJSON(json: any): CountWidgetData {
    return CountWidgetDataToJSONTyped(json, false);
}

export function CountWidgetDataToJSONTyped(value?: CountWidgetData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'total': ApiUserTasksGetPageParameterToJSON(value['total']),
    };
}

